import React, { Component } from "react";
import MapContainer, { city_part_client_type, city_proj_client_type, school_part_client_type, school_proj_client_type } from "./MapContainer";
import * as firebase from "firebase";
import FilterBar from "./FilterBar";

//#region constants
const citiesCollectionName = "map-data-test";
//#endregion

//#region helper classes, methods
function copyArray(array) {
  //only works for primitive types
  var copy = [];
  array.forEach((value) => copy.push(value));
  return copy;
}
function cityIncludesYear(cityObject, year) {
  const yearsArray = cityObject.yearsArray;
  const years = yearsArray.map((year) => year.year);
  return years.includes(year);
}

function shouldFilterProvider(currentProviderFilterValues) {
  return currentProviderFilterValues.length === 1;
}

function range(start, stop, step) {
  var a = [start],
    b = start;
  while (b < stop) {
    a.push((b += step || 1));
  }
  return a;
}

/* Creates a uppercase hex number with at least length digits from a given number */
function fixedHex(number, length){
  var str = number.toString(16).toUpperCase();
  while(str.length < length)
      str = "0" + str;
  return str;
}

/* Creates a unicode literal based on the string */    
function unicodeLiteral(str){
  var i;
  var result = "";
  for( i = 0; i < str.length; ++i){
      /* You should probably replace this by an isASCII test */
      if(str.charCodeAt(i) > 126 || str.charCodeAt(i) < 32)
          result += "\\u" + fixedHex(str.charCodeAt(i),4);
      else
          result += str[i];
  }

  return result;
}
//#endregion

//#region filter test methods - return true if city passes the test
function filterClientType(cityObject) {
  if (this.currentValues == undefined) {
    return true;
  } else {
    console.log(unicodeLiteral(cityObject.client_type), unicodeLiteral(this.currentValues[0]));
    console.log(this.currentValues);
    const cityInsideFilterSet = this.currentValues.includes(
      cityObject.client_type
    );
    return cityInsideFilterSet;
  }
}

function filterYears(cityObject) {
  if (this.currentValues == undefined) {
    return true;
  } else {
    if (this.flag) {
      const isActive = cityObject.yearsArray.filter(year => year.still_active).length > 0;
      return isActive;
    } else {
      // const yearsIntersection = this.currentValues.filter((year) =>
      //   cityIncludesYear(cityObject, year)
      // );
      // const cityInsideFilterSet = yearsIntersection.length > 0;
      return true;
    }
  }
}

function filterPopulation(cityObject) {
  if (this.currentValues == undefined || cityObject.client_type !== city_part_client_type || cityObject.client_type !== city_proj_client_type) {
    return true;
  } else {
    const minBoundary = this.currentValues[0];
    const maxBoundary = this.currentValues[1];
    const cityPopulation = cityObject.inhabitants_count;
    const cityInsideFilteredSet =
      minBoundary <= cityPopulation && cityPopulation <= maxBoundary;
    return cityInsideFilteredSet;
  }
}

function filterBudget(cityObject) {
  if (this.currentValues == undefined) {
    return true;
  } else {
    const yearsArray = cityObject.yearsArray;
    const minBoundary = this.currentValues[0];
    const maxBoundary = this.currentValues[1];
    const resultsArray = yearsArray.map((yearsObject) => {
      const yearsBudget = yearsObject.budget;
      if(yearsBudget === null || yearsBudget === undefined || Number.isNaN(yearsBudget)) {
        return true;
      }
      return minBoundary <= yearsBudget && yearsBudget <= maxBoundary;
    });
    const isInsideFilteredSet = resultsArray.includes(true);
    //at least one year has to pass
    return isInsideFilteredSet;
  }
}

function filterVotersCount(cityObject) {
  if (this.currentValues == undefined) {
    return true;
  } else {
    const yearsArray = cityObject.yearsArray;
    const minBoundary = this.currentValues[0];
    const maxBoundary = this.currentValues[1];
    const resultsArray = yearsArray.map((yearsObject) => {
      const yearsVotersCount = yearsObject.voters_count;
      if (Number.isNaN(yearsVotersCount)) {
        return true;
      }
      return minBoundary <= yearsVotersCount && yearsVotersCount <= maxBoundary;
    });
    const isInsideFilteredSet = resultsArray.includes(true);
    //at least one year has to pass
    return isInsideFilteredSet;
  }
}

function filterProvider(cityObject) {
  if (this.currentValues == undefined) {
    return true;
  } else if (shouldFilterProvider(this.currentValues)) {
    const yearsArray = cityObject.yearsArray;
    const providerFilterValue = this.currentValues[0];
    const resultsArray = yearsArray.map((yearsObject) => {
      const yearsProvider = yearsObject.provider;
      return yearsProvider === providerFilterValue;
    });
    const isInsideFilteredSet = resultsArray.includes(true);
    //at least one year has to pass
    return isInsideFilteredSet;
  } else {
    return true;
  }
}

//#endregion

//#region object constructors
function Year(year, voters_count, budget, provider, link) {
  this.year = year;
  this.voters_count = voters_count;
  this.budget = budget;
  this.provider = provider;
  this.link = link;
  //getter methods??
}

function City(city_name, client_type, inhabitants_count, location) {
  this.city_name = city_name;
  this.client_type = client_type;
  this.inhabitants_count = inhabitants_count;
  this.location = location;
  this.yearsArray = [];
  this.addYear = function (yearObject) {
    this.yearsArray.push(yearObject);
    this.yearsArray.sort(
      (yearObject1, yearObject2) => yearObject1.year - yearObject2.year
    );
  };
  //getter methods?
}

function Filter(attribute_name, initValues, filterCityMethod) {
  this.attribute_name = attribute_name;
  this.initValues = initValues;
  this.currentValues = copyArray(initValues);
  this.reset = function () {
    this.currentValues = copyArray(this.initValues);
  };
  this.setCurrentValues = function (values) {
    this.currentValues = values;
  };
  this.filterCity = filterCityMethod;
}

function FlagFilter(
  attribute_name,
  initFlagValue,
  initValues,
  filterCityMethod
) {
  this.attribute_name = attribute_name;
  this.flag = initFlagValue;
  this.initValues = initValues;
  this.currentValues = copyArray(initValues);
  this.reset = function () {
    this.currentValues = copyArray(this.initValues);
    this.flag = false;
  };
  this.setCurrentValues = function (values, flag) {
    this.currentValues = values;
    this.flag = flag;
  };
  this.filterCity = filterCityMethod;
}

function FilterSet() {
  this.filtersArray = [];
  this.addFilter = function (filterObject) {
    this.filtersArray.push(filterObject);
  };
  this.reset = function () {
    this.filtersArray.forEach((filterObject) => filterObject.reset());
  };
  this.getFilter = function (attribute_name) {
    const filter = this.filtersArray.find(
      (filter) => filter.attribute_name === attribute_name
    );
    return filter;
  };
  this.cityInsideFilteredSet = function (cityObject) {
    //js foreach doesnt have a break keyword
    //using resultsArray - I find it cleaner than a regular for-loop
    const resultsArray = this.filtersArray.map((filterObject) =>
      filterObject.filterCity(cityObject)
    );
    console.log(resultsArray);
    const isInsideFilteredSet = !resultsArray.includes(false);
    return isInsideFilteredSet;
  };
  this.filterCities = function (citiesArray) {
    return citiesArray.filter((cityObject) =>
      this.cityInsideFilteredSet(cityObject)
    );
  };
}
//#endregion
class MapApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allCities: [],
      filteredCities: [],
      filterSetObject: {},
    };
    this.initializeFilterSetObject();
  }

  render() {
    return (
      <React.Fragment>
        <FilterBar
          updateFilteredCities={this.updateFilteredCities}
          changeFilterValues={this.changeFilterValues}
          filterSetObject={this.state.filterSetObject}
          resetFilterValues={this.resetFilterValues}
          showProviderFilter={this.props.showAllProviders}
        ></FilterBar>
        <MapContainer
          cities={this.state.filteredCities}
          showProviderLegend={this.props.showAllProviders}
        />
      </React.Fragment>
    );
  }

  async componentDidMount() {
    await this.fetchPlaces();
    this.initializeFilterSetObject();
    this.updateFilteredCities();
  }

  initializeFilterSetObject() {
    var populationInit = [Number.MAX_VALUE, Number.MIN_VALUE];
    var votersInit = [Number.MAX_VALUE, Number.MIN_VALUE];
    var budgetInit = [Number.MAX_VALUE, Number.MIN_VALUE];
    //var yearsInit = range(2015, new Date().getFullYear(), 1);

    this.state.allCities.forEach((city) => {
      if (city.inhabitants_count <= populationInit[0]) {
        populationInit[0] = city.inhabitants_count;
      }
      if (city.inhabitants_count >= populationInit[1]) {
        populationInit[1] = city.inhabitants_count;
      }
      city.yearsArray.forEach((year) => {
        if (year.voters_count <= votersInit[0]) {
          votersInit[0] = year.voters_count;
        }
        if (year.voters_count >= votersInit[1]) {
          votersInit[1] = year.voters_count;
        }
        if (year.budget <= budgetInit[0]) {
          budgetInit[0] = year.budget;
        }
        if (year.budget >= budgetInit[1]) {
          budgetInit[1] = year.budget;
        }
      });
    });
    const budgetFilter = new Filter("budget", budgetInit, filterBudget);
    const populationFilter = new Filter(
      "inhabitants_count",
      populationInit,
      filterPopulation
    );
    const votersFilter = new Filter(
      "voters_count",
      votersInit,
      filterVotersCount
    );
    //from first ever ever to current year
    const yearsFilter = new FlagFilter("years", false, [], filterYears);
    const clientTypeFilter = new Filter(
      "client_type",
      [school_proj_client_type, school_part_client_type, city_proj_client_type, city_part_client_type],
      filterClientType
    );
    let providerFilter = new Filter(
      "provider",
      ["ostatni", "participace21"],
      filterProvider
    );

    if (!this.props.showAllProviders) {
      providerFilter = new Filter(
        "participace21",
        ["participace21"],
        filterProvider
      )
    }
    if (this.props.showClients !== undefined) {
      clientTypeFilter.setCurrentValues(this.props.showClients);
    }

    var newFilterSetObject = new FilterSet();
    newFilterSetObject.addFilter(budgetFilter);
    newFilterSetObject.addFilter(populationFilter);
    newFilterSetObject.addFilter(votersFilter);
    newFilterSetObject.addFilter(yearsFilter);
    newFilterSetObject.addFilter(clientTypeFilter);
    newFilterSetObject.addFilter(providerFilter);

    this.state.filterSetObject = newFilterSetObject;
  }

  changeFilterValues = (attribute_name) => (filterValue, flagValue) => {
    var filter = this.state.filterSetObject.getFilter(attribute_name);
    if (flagValue === undefined) {
      filter.setCurrentValues(filterValue);
    } else {
      filter.setCurrentValues(filterValue, flagValue);
    }
    this.updateFilteredCities();
  };

  resetFilterValues = () => {
    this.state.filterSetObject.reset();
    this.updateFilteredCities();
  };

  updateFilteredCities = () => {
    var filterSetObject = this.state.filterSetObject;
    var allCities = this.state.allCities;
    var newFilteredCities = filterSetObject.filterCities(allCities);
    this.setState({
      filteredCities: newFilteredCities,
    });
  };

  async fetchPlaces() {
    var collectionRef = firebase.firestore().collection(citiesCollectionName);
    const citiesSnapshot = await collectionRef.get();
    var citiesBuffer = [];
    for (let i = 0; i < citiesSnapshot.docs.length; i++) {
      const doc = citiesSnapshot.docs[i];
      var dbCity = doc.data();
      var city = new City(
        dbCity.name,
        dbCity.client_type,
        dbCity.population,
        dbCity.location
      );
      dbCity.years.forEach((year) => {
        city.addYear(year);
      });
      citiesBuffer.push(city);
    }
    this.setState({
      allCities: citiesBuffer,
      filterCities: citiesBuffer,
    });
  }
}

export default MapApp;
